// Locks body to prevent scrolling in modals.
// See: https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
export default function useBodyScrollLock() {
  function disableBodyScroll() {
    document.body.style.position = 'fixed'
  }

  function enableBodyScroll() {
    document.body.style.position = 'static'
  }

  return { disableBodyScroll, enableBodyScroll }
}
